import * as Sentry from "@sentry/nuxt";
import { useRuntimeConfig } from "nuxt/app";

const config = useRuntimeConfig();
const dsn = config.public.SENTRY_DSN as string;

if (dsn) {
  Sentry.init({
    dsn,
    environment: (config.public.SENTRY_ENVIRONMENT as string) || "production",
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })
    ],
    beforeSend(event) {
      if (event.request?.data) {
        const sensitive = ["password", "token", "email"];
        const data = event.request.data as Record<string, unknown>;
        sensitive.forEach((key) => {
          if (key in data) data[key] = "[Filtered]";
        });
      }
      return event;
    }
  });
}
